import axios from '../axios';

export const all = (params = {}) => {
  return axios.get('/navigation-links', { params });
};

export const getByLanguage = (language, params = {}) => {
  return axios.get(`/navigation-links/by-language/${language}`, { params });
};

export const show = (id, params = {}) => {
  return axios.get(`/navigation-links/${id}`, { params });
};

export const store = (payload) => {
  return axios.post('/navigation-links', payload);
};

export const update = (id, payload) => {
  return axios.put(`/navigation-links/${id}`, payload);
};

export const updateOrCreate = (payload) => {
  return axios.post('/navigation-links/update-or-create', payload);
};

export const destroy = (id) => {
  return axios.delete(`/navigation-links/${id}`);
};
